import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
	selector: 'app-privacy',
	templateUrl: './privacy.component.html',
	styleUrls: ['./privacy.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Privacy Component.
 */
export class PrivacyComponent implements OnInit
{
	/**
	 * Constructor.
	 */
	public constructor(
		private location: Location
	)
	{}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{}

	/**
	 * Eventhandler: Back.
	 */
	public onBack()
	{
		this.location.back();
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/privacy/privacy.component.ts